var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EnrollNavbarSection'),_c('EnrollHeaderSection'),_c('LanguageSection'),_c('EnrollSection'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }